// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.psi-text-input > .v-input__control > .v-input__slot {\n    box-shadow: var(--textinput-box-shadow) !important;\n}\n", ""]);
// Exports
module.exports = exports;
